import { Button } from "@/modern/components/ui/button";
import { DropdownMenu, DropdownMenuItem, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuSeparator } from "@/modern/components/ui/dropdown-menu";
import { MoreVertical, Link, Copy, Trash2 } from "lucide-react";
import { useEntityNotesContext } from "../context/EntityNotesContext";

export const NotesMenu = () => {
  const { selectedNote, copyNoteLink, duplicateNoteRecord, deleteNote, handleClearSelectedNote, handleCloseEditor, canEditNote, newNote } = useEntityNotesContext();
  const noteRecord = selectedNote.noteRecord;
  const canEdit = newNote ? false : noteRecord ? canEditNote(noteRecord) : false;

  if (!noteRecord) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon-sm">
            <MoreVertical className="size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuItem onClick={() => copyNoteLink(noteRecord)}>
            <Link className="size-4" />
            Copy Link
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => duplicateNoteRecord(noteRecord)}>
            <Copy className="size-4" />
            Duplicate Note
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            disabled={!canEdit}
            onClick={async () => {
              const isDelete = await deleteNote(noteRecord.id);
              if (isDelete) {
                handleClearSelectedNote();
                handleCloseEditor();
              }
            }}
            className="text-red-600 dark:text-red-400 focus:text-red-700 dark:focus:text-red-300 focus:bg-red-50 dark:focus:bg-red-950/30"
          >
            <Trash2 className="size-4" />
            Delete Note
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
